<template>
  <div class="modal-start-link">
    <div class="modal-input-box">
      <div>
        <p style="text-align: left; font-size: x-large; font-weight: 600;">
          <span style="margin-right: 8px;" class="mdi mdi-camcorder-box mdi-24px"></span>ウェブ会議
        </p>
        <p style="text-align: left; font-color: #555; font-size: smaller; font-weight: 600;"
          v-if="videoInterviewInfo.company_name">
          {{videoInterviewInfo.company_name}}
        </p>
      </div>
      <video @loadeddata="playVideo"
        id="pre_local_video"
        class="pre-video"
        muted
        playsinline
        autoplay></video>
      <button class="mute-button pre-mute"
        id="btn_mute"
        type="button"
        @click="setAudioSwitch(false)"
        v-if="!isMute">
        <span class="mdi mdi-microphone mdi-24px"></span>
      </button>
      <button class="mute-button pre-mute"
        id="btn_mute"
        type="button"
        @click="setAudioSwitch(true)"
        v-if="isMute">
        <span class="mdi mdi-microphone-off mdi-24px"></span>
      </button>
      <button class="blind-button pre-blind"
        id="btn_blind"
        type="button"
        @click="setVideoSwitch(false)"
        v-if="!isBlind">
        <span class="mdi mdi-camcorder mdi-24px"></span>
      </button>
      <button class="blind-button pre-blind"
        id="btn_blind"
        type="button"
        @click="setVideoSwitch(true)"
        v-if="isBlind">
        <span class="mdi mdi-camcorder-off mdi-24px"></span>
      </button>
      <div class="video-volume pre-volume" v-if="!isMute">
        <meter high="0.25" max="1" :value="getVolume"></meter>
        <div class="v_circle"/>
        <div class="v_line_fix"/>
      </div>
      <p class="connect-desc">現在通話中の人数: {{memberNum}}</p>
      <div class="name-box">
        <p style="font-weight: 600; padding: 8px;">お名前を入力してください</p>
        <input placeholder="入力..." class="input" maxlength="32" v-model="inputs.inputName"/>
      </div>
      <div class="pass-box">
        <p style="font-weight: 600; padding: 8px;"
          v-if="videoInterviewInfo.aikotoba">合言葉を入力してください</p>
        <input placeholder="入力..." class="input"
          v-model="inputs.inputAikotoba"
          v-if="videoInterviewInfo.aikotoba"/>
      </div>
      <button class="button"
        style="margin-top: 8px; height: 48px; background: green; color: white;"
        id="btn_connect"
        type="button"
        @click="startConnect()">
        <span class="mdi mdi-camcorder mdi-24px" style="margin-right: 16px;"></span>通話する
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isBlind: {
      type: Boolean,
      required: true
    },
    isMute: {
      type: Boolean,
      required: true
    },
    inputs: {
      type: Object,
      required: true
    },
    videoInterviewInfo: {
      type: Object,
      required: true
    },
    memberNum: {
      type: Number,
      required: true
    },
    getVolume: {
      type: Number,
      required: true
    },
  },
  methods: {
    async playVideo (event) {
      await event.target.play()
    },
    setAudioSwitch (flg) {
      this.$emit('setAudioSwitch', flg)
    },
    setVideoSwitch (flg) {
      this.$emit('setVideoSwitch', flg)
    },
    getAuth () {
      if (!this.videoInterviewInfo.aikotoba) return false
      else if (!this.inputs.inputAikotoba) return true
      else if (this.inputs.inputAikotoba === this.videoInterviewInfo.aikotoba) return false
      else return true
    },
    startConnect () {
      if (!this.getAuth()) {
        this.$emit('startConnect')
      } else {
        alert('合言葉が違います。もう一度入力しなおしてください。')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-start-link {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #FEFEFE;
  padding: 16px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.mute-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(55, 55, 55, 0.3);
  color: white;
  border: none;
  margin: 15px;
}
.blind-button {
  height: 64px;
  width: 64px;
  border-radius: 50%;
  background: rgba(55, 55, 55, 0.3);
  color: white;
  border: none;
  margin: 15px;
}
.modal-input-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 500px;
  height: auto;
  padding: 32px 16px;
  background: #FEFEFE;
  border: solid thin #ccc;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  position: relative;
  .pre-video {
    width: 100%;
    height: 240px;
    background: #ccc;
  }
  .name-box, .pass-box, .connect-desc {
    position: relative;
    margin-left: 0;
    top: 0;
    margin-top: 8px;
    text-align: left;
  }
  .pre-mute {
    position: absolute;
    left: 240px;
    top: 240px;
  }
  .pre-blind {
    position: absolute;
    left: 160px;
    top: 240px;
  }
  .video-volume {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #fff;
  }
  meter {
    height: 24px;
    width: 24px;
    transform: rotate(-90deg);
    transition: 0.45s;
  }
  .pre-volume {
    position: absolute;
    top: 240px;
  }
  .v_circle {
    position: absolute;
    top:   2px;
    left:  -6px;
    width:  36px;
    height: 36px;
    border: solid 10px #fff;
    border-color:   transparent transparent  #fff transparent;
    border-radius: 100px 0px 100px 100px;
  }
  .v_line_fix {
    top: 36px;
    left: -12px;
    position: absolute;
    margin-left: 20px;
    width: 8px;
    height: 8px;
    background-color: #fff;
  }
}
@media screen and (max-width: 500px) {
  .modal-input-box {
    width: calc(100% - 8px);
    position: relative;
    .pre-video {
      height: 200px;
    }
    .pre-mute {
      position: absolute;
      left: calc(50% - 80px);
      top: 220px;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
    }
    .pre-blind {
      position: absolute;
      left: calc(50% + 40px);
      top: 220px;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
    }
  }
}

/* safari */
::-webkit-full-page-media, :future, :root .v_circle {
  display: none;
}
::-webkit-full-page-media, :future, :root .v_line_fix {
  display: none;
}
::-webkit-full-page-media, :future, :root .video-volume {
  padding: 4px 4px 2px 2px;
  border-radius: 2px;
  background: white;
}

/* firefox */
@-moz-document url-prefix() {
  .v_circle {
    display: none;
  }
  .v_line_fix {
    display: none;
  }
  .video-volume {
    padding: 4px 4px 2px 2px;
    border-radius: 2px;
    background: white;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoInterview/organisms/StartView.vue